module.exports = __webpack_public_path__ + "static/media/bitcoin.cca16df3.svg";